import dynamic from 'next/dynamic';
import React from 'react';
import Script from 'next/script';
import { OrganizationJsonLd } from '@/shared/types/seo';

const Header = dynamic(() => import('@/components/Commons/Layout/Header'));
const Footer = dynamic(() => import('@/components/Commons/Layout/Footer'));

interface LayoutProps {
  structured?: OrganizationJsonLd;
  children: React.ReactNode;
  hideFooter?: boolean;
  hideHeader?: boolean;
  stickyHeader?: boolean;
  hideHeaderMenu?: boolean;
}
export default function Layout({
  children,
  structured,
  hideFooter = false,
  hideHeader = false,
  stickyHeader = true,
  hideHeaderMenu = false,
}: LayoutProps) {
  return (
    <div className="aika-layout relative w-screen overflow-x-hidden" id="aika-layout-root">
      <Script
        id="application/ld+json"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structured) }}
      />
      {!hideHeader && <Header sticky={stickyHeader} hideMenu={hideHeaderMenu} />}
      <main className={hideHeader ? 'hide-header' : ''}>{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}
